import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog, { DialogTitle, DialogActions, DialogContent, DialogContentText } from 'material-ui/Dialog';

import * as InspectionActions from '../../inspection/inspection.actions';
import * as ReportsActions from '../../reports/reports.actions';
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});
class RemoveReportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      submitSuccess: false,
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      submitSuccess: false,
    });
  };
  handleRemove = () => {
    const { deleteInspection, reports, toggleReportSelection } = this.props;
    this.setState({ submitting: true });
    let results = [];
    reports.forEach(inspectionId => {
      let promise = deleteInspection(inspectionId);
      results = [...results, promise];
    });
    Promise.all(results)
      .then(actions => {
        if (
          actions.some(action => {
            return !action.response || action.response.status !== 'ok';
          })
        ) {
          this.setState({
            submitting: false,
            submitted: true,
            submitSuccess: false,
          });
        } else {
          this.setState({
            submitting: false,
            submitted: true,
            submitSuccess: true,
          });
        }
        actions.forEach(action => {
          if (action.response && action.response.status === 'ok' && action.payload && action.payload.id) {
            toggleReportSelection(action.payload.id);
          }
        });
      })
      .catch(error => {
        this.setState({
          submitting: false,
          submitted: true,
          submitSuccess: false,
        });
      });
  };

  renderRequest() {
    const { reports } = this.props;
    const { submitting } = this.state;
    const count = reports.length;
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Tahdotko varmasti poistaa {count} raporttia? Toimintoa ei voi peruuttaa.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={submitting} onClick={this.handleCancel}>
            Peruuta
          </Button>
          <Button disabled={submitting} onClick={this.handleRemove} color="primary">
            Poista
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogContent>
          <DialogContentText>Raportin poistaminen onnistui.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Takaisin
          </Button>
        </DialogActions>
      </div>
    );
  }
  renderFailure() {
    return (
      <div>
        <DialogTitle>Poisto ei onnistu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Yhden tai useamman raportin poistaminen palvelusta ei onnistunut. Tarkista verkkoyhteytesi ja yritä
            myöhemmin uudelleen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Takaisin</Button>
        </DialogActions>
      </div>
    );
  }
  render() {
    const { open } = this.props;
    const { submitted, submitSuccess } = this.state;
    if (!open) {
      return null;
    }
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        {!submitted ? this.renderRequest() : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}

export default withRouter(
  connect(null, Object.assign({}, InspectionActions, ReportsActions))(withStyles(styles)(RemoveReportDialog))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/RemoveReportsConfirm.js